// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__2eTK3","noInteraction":"EventWrapper_noInteraction__2ICiq"};